import { useNavigate } from 'react-router-dom';
import { Button, Card, Stack, Text } from '@srichaitra/ui';
import { Page } from '@srichaitra/common';
import { labels, routes } from '@srichaitra/constants';

/** Shown for any URL inside the signed-in area that matches no route. */
export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Page title={labels.common.notFoundHeading}>
      <Card>
        <Stack gap={4} align="flex-start">
          <Text tone="muted">{labels.common.notFoundBody}</Text>
          <Button onClick={() => navigate(routes.dashboard, { replace: true })}>
            {labels.common.backToDashboard}
          </Button>
        </Stack>
      </Card>
    </Page>
  );
}
